(function () {
  function initInvoiceForm(root) {
    if (!root || root.__lmInit) return;
    root.__lmInit = true;

    const form = root.querySelector('[data-lm-form]');
    const rutInput = root.querySelector('[data-lm-rut]');
    const rutError = root.querySelector('[data-lm-rut-error]');
    const regionSel = root.querySelector('[data-lm-region]');
    const comunaSel = root.querySelector('[data-lm-comuna]');
    const btnSave = root.querySelector('[data-lm-save]');
    const btnClear = root.querySelector('[data-lm-clear]');
    const status = root.querySelector('[data-lm-status]');

    const mappingEl = root.querySelector('#invoice-regions-mapping');
    const mapping = mappingEl ? JSON.parse(mappingEl.textContent) : {};

    const translations = (typeof Theme !== 'undefined' && Theme.translations) || {};
    const comunaPlaceholder = translations.invoice_comuna_placeholder || 'Selecciona una comuna';
    const savingText = translations.invoice_saving_text || 'Guardando…';
    const clearingText = translations.invoice_clearing_text || 'Limpiando…';

    function setStatus(msg) {
      if (status) status.textContent = msg || '';
    }

    function validateRut(rut) {
      const clean = String(rut).replace(/[^0-9kK]/g, '').toUpperCase();
      if (clean.length < 2) return false;
      const dv = clean.slice(-1);
      const body = clean.slice(0, -1);
      if (!/^\d+$/.test(body)) return false;

      let sum = 0,
        mul = 2;
      for (let i = body.length - 1; i >= 0; i--) {
        sum += parseInt(body[i], 10) * mul;
        mul = mul === 7 ? 2 : mul + 1;
      }
      const res = 11 - (sum % 11);
      const expected = res === 11 ? '0' : res === 10 ? 'K' : String(res);
      return expected === dv;
    }

    function formatRut(rut) {
      const clean = String(rut).replace(/[^0-9kK]/g, '').toUpperCase();
      if (clean.length < 2) return rut;
      const dv = clean.slice(-1);
      const body = clean.slice(0, -1);
      return `${parseInt(body, 10)}-${dv}`;
    }

    function buildNote(a) {
      return [
        'FACTURACION (EMPRESA)',
        `RUT: ${a.RUTEmpresa || ''}`,
        `Razon social: ${a.RazonSocial || ''}`,
        `Giro: ${a.Giro || ''}`,
        `Direccion: ${a.DireccionEmpresa || ''}`,
        `Region: ${a.Region || ''}`,
        `Comuna: ${a.Comuna || ''}`,
      ].join('\\n');
    }

    function fillCommunes(region, selected) {
      const communes = mapping[region] || [];
      const wanted = selected || comunaSel.dataset.selected || '';
      comunaSel.innerHTML =
        `<option value="">${comunaPlaceholder}</option>` +
        communes.map((c) => `<option value="${c}">${c}</option>`).join('');
      if (wanted) {
        const opt = Array.from(comunaSel.options).find((o) => o.value === wanted);
        if (opt) opt.selected = true;
      }
    }

    function checkValidity() {
      const invalid = form.querySelector(':invalid');
      btnSave.disabled = !!invalid;
    }

    // Whether the cart already holds a saved invoice (used to decide which button to show).
    let hasSavedInvoice = !!(rutInput && rutInput.value.trim());
    // Whether the user has started editing since the last load/save/clear.
    let dirty = false;

    function checkoutButtons() {
      return document.querySelectorAll('.cart__ctas button[name="checkout"], .cart__ctas button#checkout');
    }

    // Only re-enables checkout buttons that this component disabled itself, so it never
    // overrides an unrelated disabled state (e.g. an empty cart).
    function setCheckoutBlocked(blocked) {
      checkoutButtons().forEach((btn) => {
        if (blocked) {
          btn.dataset.invoiceFormBlocking = 'true';
          btn.disabled = true;
        } else if (btn.dataset.invoiceFormBlocking === 'true') {
          delete btn.dataset.invoiceFormBlocking;
          btn.disabled = false;
        }
      });
    }

    function updateButtonsVisibility() {
      const showClear = !dirty && hasSavedInvoice;
      if (btnClear) btnClear.style.display = showClear ? '' : 'none';
      if (btnSave) btnSave.style.display = showClear ? 'none' : '';
    }

    function markDirty() {
      if (dirty) return;
      dirty = true;
      updateButtonsVisibility();
      setCheckoutBlocked(true);
    }

    regionSel &&
      regionSel.addEventListener('change', () => {
        fillCommunes(regionSel.value, '');
        checkValidity();
      });

    rutInput &&
      rutInput.addEventListener('change', () => {
        const v = rutInput.value.trim();
        if (!v) return;
        const ok = validateRut(v);
        rutError.hidden = ok;
        rutInput.setCustomValidity(ok ? '' : 'RUT invalido');
        if (ok) rutInput.value = formatRut(v);
        checkValidity();
      });

    form.addEventListener('input', () => {
      markDirty();
      checkValidity();
    });

    btnSave &&
      btnSave.addEventListener('click', async () => {
        setStatus(savingText);

        if (!form.checkValidity()) {
          setStatus('Revisa los campos.');
          form.reportValidity();
          checkValidity();
          return;
        }

        const fd = new FormData(form);
        const get = (k) => (fd.get(`attributes[${k}]`) || '').toString().trim();

        const attributes = {
          RUTEmpresa: get('RUTEmpresa') || null,
          RazonSocial: get('RazonSocial') || null,
          Giro: get('Giro') || null,
          DireccionEmpresa: get('DireccionEmpresa') || null,
          Region: get('Region') || null,
          Comuna: get('Comuna') || null,
          Factura: get('RUTEmpresa') && get('RazonSocial') ? 'Sí' : null,
        };

        const note = buildNote(attributes);

        try {
          const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify({ attributes, note }),
          });
          if (!res.ok) throw new Error('cart/update failed');

          setStatus('Listo ✅');
          hasSavedInvoice = true;
          dirty = false;
          updateButtonsVisibility();
          setCheckoutBlocked(false);
        } catch (err) {
          console.error(err);
          setStatus('No se pudo guardar. Intenta nuevamente.');
        }
      });

    btnClear &&
      btnClear.addEventListener('click', async () => {
        setStatus(clearingText);

        const attributes = {
          RUTEmpresa: null,
          RazonSocial: null,
          Giro: null,
          DireccionEmpresa: null,
          Region: null,
          Comuna: null,
          Factura: null,
        };

        try {
          const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify({ attributes, note: '' }),
          });
          if (!res.ok) throw new Error('cart/update failed');

          form.reset();
          comunaSel.innerHTML = `<option value="">${comunaPlaceholder}</option>`;
          setStatus('Listo ✅');
          hasSavedInvoice = false;
          dirty = false;
          updateButtonsVisibility();
          setCheckoutBlocked(false);
          checkValidity();
        } catch (err) {
          console.error(err);
          setStatus('No se pudo limpiar. Intenta nuevamente.');
        }
      });

    fillCommunes(regionSel && regionSel.value ? regionSel.value : '', '');
    checkValidity();
    updateButtonsVisibility();
  }

  function initAll() {
    document.querySelectorAll('[data-lm-invoice]').forEach(initInvoiceForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-scan after cart updates in case new invoice-form instances were inserted
  // (e.g. a cart drawer rendered for the first time via the Section Rendering API).
  document.addEventListener('cart:update', initAll);
})();
